import radium from 'radium';
import Section from "../../../components/section/Section";
import SectionTitle from "../../../components/sectionTitle/SectionTitle";
import SelectedPaymentType from "./SelectedPaymentType";
import SelectedShipmentType from "./SelectedShipmentType";

function PaymentShipment(props) {
	const selectedShipmentTypeFee = props.selectedShipmentTypeFee
	const selectedShipmentType = props.selectedShipmentType
	const selectedPaymentType = props.selectedPaymentType
	const style = {
		sectionContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			width: '100%',
			'@media (min-width : 768px)': {
				justifyContent: 'space-between',
			}
		},
		section: {
			width: '100%',
			'@media (min-width : 768px)': {
				width: '50%',
			},
		},
		sectionLeft: {
			'@media (min-width : 768px)': {
				paddingRight: '1em'
			}
		},
		sectionRight: {
			'@media (min-width : 768px)': {
				paddingLeft: '1em'
			}
		}
	}
	return (
		<div style={style.sectionContainer}>
			<Section style={[style.section,style.sectionLeft]}>
				<SectionTitle headlineLevel={"h2"}>
					Zahlungsart
				</SectionTitle>
				<SelectedPaymentType selectedPaymentType={selectedPaymentType}/>
			</Section>
			<Section style={[style.section,style.sectionRight]}>
				<SectionTitle headlineLevel={"h2"}>
					Versandart
				</SectionTitle>
				<SelectedShipmentType
					selectedShipmentType={selectedShipmentType}
					selectedShipmentTypeFee={selectedShipmentTypeFee}/>
			</Section>
		</div>
	)
		;
}

export default radium(PaymentShipment);
